import React from 'react';
import PropTypes from 'prop-types';
import LinkedInPreview from './LinkedInPreview';
import FacebookPreview from './FacebookPreview';
import XPreview from './XPreview';
import InstagramPreview from './InstagramPreview';
import GenericPreview from './GenericPreview';

/**
 * PlatformPreviewSwitcher
 *
 * Renders the appropriate platform-specific preview component
 * based on the selected platform type.
 */
const PlatformPreviewSwitcher = ({
  platformType,
  user,
  content,
  title,
  hashtags = [],
  imageUrl,
  onRemoveImage,
  contentType,
}) => {
  const commonProps = {
    user,
    content,
    title,
    hashtags,
    imageUrl,
    onRemoveImage,
    contentType,
  };

  switch (platformType?.toLowerCase()) {
    case 'linkedin':
      return <LinkedInPreview {...commonProps} />;

    case 'facebook':
      return <FacebookPreview {...commonProps} />;

    case 'x':
    case 'twitter':
      return <XPreview {...commonProps} />;

    case 'instagram':
      return <InstagramPreview {...commonProps} />;

    case 'tiktok':
      return <GenericPreview {...commonProps} platformLabel="TikTok" />;

    default:
      return <GenericPreview {...commonProps} />;
  }
};

PlatformPreviewSwitcher.propTypes = {
  platformType: PropTypes.string,
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    avatar_url: PropTypes.string,
    headline: PropTypes.string,
    role: PropTypes.string,
  }),
  content: PropTypes.string,
  title: PropTypes.string,
  hashtags: PropTypes.arrayOf(PropTypes.string),
  imageUrl: PropTypes.string,
  onRemoveImage: PropTypes.func,
  contentType: PropTypes.string,
};

PlatformPreviewSwitcher.defaultProps = {
  platformType: null,
  content: '',
  title: '',
  hashtags: [],
};

export default PlatformPreviewSwitcher;
